import styles from "./Contact.module.css"

const Contact = () => {
    return (
        <div className={styles.container}>
            <br />
            <p>Interested in getting a field guide made for another location?</p>
            <br />
            <p>Please get in touch!</p>
            <br />
            <p>jamesmaino@gmail.com</p>
        </div>
    )

}

export default Contact